import { Observable, of } from "rxjs";

import { CustomerFraudToken } from "./fraud-prevention.model";
import { FraudPreventionService } from "./fraud-prevention.service";

export class NoopFraudPreventionService extends FraudPreventionService {
	loadScript(): void {}

	unloadScript(): void {}

	getCustomerFraudToken$(): Observable<CustomerFraudToken | undefined> {
		return of(undefined);
	}

	init(): void {}
}
